/* eslint-disable */
// HeaderControl 用 的搜索框
import React, { useState, useEffect } from 'react'
import { Input } from 'antd'
import { omit } from 'lodash'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'

const InputC = (props) => {
  const {     
    propsClassName, propsClassSpan, className, style,// 样式 className
    modalProps, label, // 组件 功能参数
    options, query, value, searchKey, // 组件 数据源
    path, clearKey, requestType, killPending, // 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props

  const [ useValue, setUseValue ] = useState(query[searchKey])
  useEffect(() => {
    return setUseValue(query[searchKey])
  }, [query.refQ, query[searchKey]])

  const handleSearch = (event) => {
    const e = event.target.value
    console.log('e', e)
    setUseValue(e)
    // ----- 提交组件 -----------
    handleControl(
      props,
      { [searchKey]: e }
    )
  }

  return (
    <div className={propsClassName}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <Input
        style={style}
        className={className}
        {...modalProps}
        value={useValue}
        onChange={handleSearch}
      />
    </div>
  )
}

export default InputC

InputC.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  query: {},
  style: { width: 240 },
  killPending: false
}
